import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTrainers } from '../../Redux/Actions/actions';
import CardTrainerContainer from '../../Components/CardTrainerContainer/CardTrainerContainer';

const ListTrainer = () => {
  const dispatch = useDispatch();
  const { trainers, trainersTotal, trainersLoading, trainersError } = useSelector(state => state);
  const gym = useSelector(state => state.gym);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (gym?.id) {
      dispatch(getTrainers(gym.id, search));
    }
  }, [dispatch, gym, search]);

  return (
    <div>
      <h2>Lista de Entrenadores</h2>
      <input
        type="text"
        placeholder="Buscar por DNI, nombre o apellido..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: '1rem', padding: '0.5rem', width: '100%', maxWidth: 400 }}
      />
      <div style={{ marginBottom: '1rem' }}>
        <strong>Total encontrados:</strong> {trainersTotal}
      </div>
      {trainersLoading && <p>Cargando entrenadores...</p>}
      {trainersError && <p style={{ color: 'red' }}>{trainersError}</p>}
      <CardTrainerContainer trainers={trainers} />
    </div>
  );
};

export default ListTrainer;